/**
 * Predictive Search
 * Fetches results from Shopify's /search/suggest.json as the user types.
 */
(function () {
  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  const input        = overlay.querySelector('[data-search-input]');
  const resultsEl    = overlay.querySelector('[data-search-results]');
  const defaultEl    = overlay.querySelector('[data-search-default]');
  const clearBtn     = overlay.querySelector('[data-search-clear]');
  if (!input || !resultsEl || !defaultEl) return;

  let abortController = null;
  let debounceTimer   = null;

  function debounce(fn, ms) {
    return function (...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => fn.apply(this, args), ms);
    };
  }

  function formatMoney(cents) {
    if (typeof window.theme !== 'undefined' && window.theme.moneyFormat) {
      const amount = (cents / 100).toFixed(2);
      return window.theme.moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function productCard(product) {
    const img = product.image
      ? `<img src="${product.image.replace(/(\.\w+)$/, '_160x160_crop_center$1')}" alt="${product.title}" loading="lazy">`
      : '';
    const compareAt   = product.compare_at_price;
    const price       = product.price;
    const hasDiscount = compareAt && compareAt > price;
    const priceHtml   = hasDiscount
      ? `<s class="search-overlay__product-compare">${formatMoney(compareAt)}</s><span class="search-overlay__product-sale">${formatMoney(price)}</span>`
      : `<span>${formatMoney(price)}</span>`;

    return `
      <a href="${product.url}" class="search-overlay__product">
        <div class="search-overlay__product-img">${img}</div>
        <div class="search-overlay__product-info">
          <span class="search-overlay__product-title">${product.title}</span>
          <div class="search-overlay__product-price">${priceHtml}</div>
        </div>
      </a>`;
  }

  function renderResults(data) {
    const products    = data.resources?.results?.products || [];
    const collections = data.resources?.results?.collections || [];
    const pages       = data.resources?.results?.pages || [];

    if (products.length === 0 && collections.length === 0 && pages.length === 0) {
      resultsEl.innerHTML = `
        <div class="search-results__empty">
          <p>No results found. Try a different search or</p>
          // <a href="https://wa.me/${(window.theme?.whatsappNumber || '').replace(/[^\d]/g, '')}"
          //    class="btn btn--whatsapp" target="_blank" rel="noopener" style="margin-top:12px;max-width:260px;">
          //   Ask us on WhatsApp
          // </a>
          
        </div>`;
      return;
    }

    let html = '';

    if (products.length > 0) {
      html += '<div class="search-results__section">';
      html += '<div class="search-results__products">';
      products.forEach((p) => { html += productCard(p); });
      html += '</div></div>';
    }

    if (collections.length > 0) {
      html += '<div class="search-results__section">';
      html += '<h3 class="search-overlay__heading">Collections</h3>';
      html += '<ul class="search-results__list">';
      collections.forEach((c) => { html += `<li><a href="${c.url}">${c.title}</a></li>`; });
      html += '</ul></div>';
    }

    if (pages.length > 0) {
      html += '<div class="search-results__section">';
      html += '<h3 class="search-overlay__heading">Pages</h3>';
      html += '<ul class="search-results__list">';
      pages.forEach((p) => { html += `<li><a href="${p.url}">${p.title}</a></li>`; });
      html += '</ul></div>';
    }

    const query = input.value.trim();
    if (query) {
      html += `<div class="search-results__footer"><a href="/search?q=${encodeURIComponent(query)}" class="search-results__see-all">See all results for "${query}" →</a></div>`;
    }

    resultsEl.innerHTML = html;
  }

  async function fetchResults(query) {
    if (abortController) abortController.abort();
    abortController = new AbortController();
    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=8`,
        { signal: abortController.signal }
      );
      if (!res.ok) return;
      const data = await res.json();
      renderResults(data);
    } catch (err) {
      if (err.name !== 'AbortError') console.error('[search]', err);
    }
  }

  const debouncedFetch = debounce(fetchResults, 300);

  function setClearVisible(visible) {
    if (clearBtn) clearBtn.hidden = !visible;
  }

  function resetSearch() {
    input.value = '';
    setClearVisible(false);
    defaultEl.hidden = false;
    resultsEl.hidden = true;
    resultsEl.innerHTML = '';
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    setClearVisible(q.length > 0);
    if (q.length === 0) {
      defaultEl.hidden  = false;
      resultsEl.hidden  = true;
      resultsEl.innerHTML = '';
      return;
    }
    defaultEl.hidden  = true;
    resultsEl.hidden  = false;
    resultsEl.innerHTML = '<div class="search-results__loading"><span>Searching…</span></div>';
    debouncedFetch(q);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      resetSearch();
      input.focus();
    });
  }

  // Trending term click
  overlay.querySelectorAll('[data-trending-term]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const term = link.dataset.trendingTerm;
      input.value = term;
      setClearVisible(true);
      defaultEl.hidden  = true;
      resultsEl.hidden  = false;
      resultsEl.innerHTML = '<div class="search-results__loading"><span>Searching…</span></div>';
      fetchResults(term);
      input.focus();
    });
  });

  // Reset on close
  overlay.addEventListener('click', (e) => {
    if (e.target.matches('[data-search-close]') || e.target.closest('[data-search-close]')) {
      resetSearch();
    }
  });
})();
